import { useEffect, useState } from 'react';

const getReturnValues = (duration) => {
  const days = duration > 0 ? Math.floor(duration / 1000 / 60 / 60 / 24) : 0;
  const hours = duration > 0 ? Math.floor(duration / 1000 / 60 / 60) % 24 : 0;
  const minutes = duration > 0 ? Math.floor(duration / 1000 / 60) % 60 : 0;
  const seconds = duration > 0 ? Math.floor(duration / 1000) % 60 : 0;

  return [days, hours, minutes, seconds];
};

const useCountdown = (endDate) => {
  const [timeLeft, setTimeLeft] = useState(endDate - Date.now());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft(endDate - Date.now());
    }, 1000);
    return () => clearInterval(intervalId);
  }, [endDate]);

  return getReturnValues(timeLeft);
};

export default useCountdown;
